import { AuxiliumComponent } from "../auxilium-component";

export class DropdownDivider extends AuxiliumComponent {
	parsedCallback() {
		this.appendChild(document.createElementWithContents("hr", null, { className: "dropdown__divider" }));
	}
}